'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosPeople = function IoIosPeople(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.8 26.2c0.8 0.3-0.9-0.3 0 0z m0 0c2.2 0.8 3.6 2.7 3.6 5.1h-21.8c0-1.8 0.7-3.3 2.2-4.3 1.1-0.9 2.4-1 3.8-1.3 0.5-0.1 1.9-0.4 2-1s0.1-1.2 0.1-1.8c0-0.2 0-0.2-0.2-0.4-0.3-0.3-0.4-0.7-0.6-1.1-0.1-0.6-0.2-1.2-0.3-1.9-0.7 0.2-0.8-1.2-0.9-1.6-0.1-0.3-0.6-1.9 0.2-1.7-0.2-0.3-0.3-1-0.4-1.4-0.2-1.1-0.2-2.1 0.2-3.1 0.8-2 2.9-3 5-3 2.1 0.1 4 1.3 4.6 3.3 0.4 1 0.3 2.1 0.1 3.1-0.1 0.4-0.1 0.8-0.3 1.1 0.8-0.2 0.3 1.6 0.2 1.8-0.1 0.4-0.2 1.7-0.9 1.5-0.1 0.8-0.2 1.7-0.5 2.4-0.1 0.2-0.6 0.7-0.6 0.8v0.9c0 0.4 0 0.8 0.2 1.2s0.7 0.5 1.1 0.6c1.1 0.4 2.1 0.4 3.2 0.8z m-16.1-1z m0 0c-0.7 0.3-1.4 0.8-1.9 1.4-0.1 0.2-0.5 0.9-0.5 0.9h-6.3c0-1.6 0.9-2.7 2.3-3.1 0.5-0.2 2.2-0.3 2.4-0.9 0.1-0.4 0.1-0.8 0.1-1.2-0.8 0-1.9-0.1-2.5-0.6-0.2-0.1 0.2-0.7 0.3-0.9 0.1-0.3 0.1-0.6 0.2-0.9 0.1-0.7 0.1-1.5 0.1-2.2 0-1.2-0.1-2.7 0.6-3.8 0.6-1 1.8-1.4 3-1.4 1.9 0 3.3 1 3.7 2.9 0.2 1.2 0 2.5 0.1 3.7 0 0.7 0.2 1.3 0.4 1.9 0.1 0.2 0.4 0.6 0.2 0.7l-0.4 0.3c-0.4 0.1-0.9 0.2-1.4 0.3 0 0-0.6 0-0.7 0s0 0.7 0 0.9c0 0.3 0.1 0.5 0.4 0.5 0.5 0.2 1.5 0.3 1.8 0.7 0.2 0.2 0.1 0.4-0.1 0.4-0.6 0-1.1 0.1-1.7 0.4 0.2-0.1 0.2-0.2 0 0-0.7 0.3-0.4 0.1-0.1 0z m23.9-0.8c1.4 0.4 2.4 1.5 2.4 3.1h-6.2c-0.2-0.6-0.8-1.1-1.3-1.5-0.6-0.5-1.4-1-2.2-1.2-0.2 0-1.2 0.1-1-0.3 0.2-0.4 0.7-0.4 1-0.5s1.2-0.2 1.3-0.6c0 0 0-1.1 0-1.1-0.5 0-1 0-1.4-0.1-0.4-0.1-0.6-0.2-0.9-0.3-0.5-0.3-0.2-0.5 0-0.9 1.1-2.5-0.8-6.9 2.5-8.2 1.2-0.5 2.7-0.4 3.7 0.2 1.2 0.7 1.6 2.2 1.6 3.5 0 1.5-0.3 3.4 0.6 4.8 0.1 0.3 0.3 0.3 0 0.5-0.2 0.1-0.4 0.1-0.5 0.2l-1 0.2s-0.7 0.1-1 0.1c0 0.3-0.1 1 0.1 1.3 0.5 0.5 1.7 0.5 2.3 0.8z' })
        )
    );
};

exports.default = IoIosPeople;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-people.js
// module id = 2265
// module chunks = 0